var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiotableroIcono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.588623,
    y: 10.7083,
    width: 8.74706,
    height: 22.4924,
    fill: "#2A363B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.835,
    y: 0.711548,
    width: 8.74706,
    height: 32.4891,
    fill: "#2A363B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.0811,
    y: 3.21069,
    width: 8.74706,
    height: 29.9899,
    fill: "#2A363B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiotableroIcono);
export default __webpack_public_path__ + "static/media/biotablero-icono.a5afe6d6cdcc22c7512648b7e11378ff.svg";
export { ForwardRef as ReactComponent };